module.exports = __webpack_public_path__ + "static/img/lili-logo-white.66cbe07.svg";


//////////////////
// WEBPACK FOOTER
// ./src/RF_assets/images/lili-logo-white.svg
// module id = Ayqe
// module chunks = 28